module.exports = __webpack_public_path__ + "img/topdiy.dbcc150d.png";